import React from 'react'

const Tickets = () => {
  return (
    <>
      	<div class="extra">
		<div class="extra_container">
			<div class="background_image" style={{"background-image":"url(images/extra.jpg)"}}></div>
			<div class="container">
				<div class="row">
					<div class="col-lg-9">
						<div class="extra_content d-flex flex-column align-items-start justify-content-center">
							<div class="extra_title"><h1>Get your tickets now!</h1></div>
							<div class="extra_text">
								<p>In vitae nisi aliquam, scelerisque leo a, volutpat sem. Vivamus rutrum dui fermentum eros hendrerit, id lobortis leo volutpat. Maecenas sollicitudin est in libero pretium interdum</p>
							</div>
							<div class="extra_button"><a href="#">Buy Now</a></div>
						</div>
					</div>
				</div>
			</div>		
		</div>
	</div>
    </>
  )
}

export default Tickets
